// Campus photo for /colleges/university-of-rochester: CC BY-SA 2.0, by Ryan Hyde from Ann Arbor, United States, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ARush_Rhees_Library_(8695462255).jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-rochester/; credited under the photo.
const photo = {
    "slug": "university-of-rochester",
    "alt": "Rush Rhees Library and its dome seen across the quad at the University of Rochester in Rochester, New York",
    "src": "/colleges/university-of-rochester/campus-1600.webp",
    "srcSmall": "/colleges/university-of-rochester/campus-800.webp",
    "srcMid": "/colleges/university-of-rochester/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-rochester/og.jpg",
    "title": "Rush Rhees Library (8695462255)",
    "author": "Ryan Hyde from Ann Arbor, United States",
    "license": "CC BY-SA 2.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/2.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ARush_Rhees_Library_(8695462255).jpg",
    "read": "2026-10-01"
};

export default photo;
